import React from 'react';

import LabeledSelectBox from 'components/consumer/LabeledSelectBox';
import MobileOnly from 'components/consumer/MobileOnly';
import TabletAndDesktopOnly from 'components/consumer/TabletAndDesktopOnly';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';
import {
  SORT_ORDER_TO_ALGOLIA_INDEX,
  ALGOLIA_INDEX_TO_SORT_ORDER,
} from 'commons/constants';

const ProductListingSortBy = ({ sortByOptions = [] }) => {
  const {
    currentProductIndex,
    updateCurrentProductIndex,
  } = useAdvancedSearchContext();

  const handleChange = e => {
    const updatedValue = e?.target?.value;
    updateCurrentProductIndex(
      SORT_ORDER_TO_ALGOLIA_INDEX?.[updatedValue] ??
        SORT_ORDER_TO_ALGOLIA_INDEX.featured
    );
  };

  return (
    <div className="max-w-[215px] md:min-w-[16rem]">
      <MobileOnly>
        <LabeledSelectBox
          className="md:hidden"
          label="Sort by"
          options={sortByOptions}
          value={ALGOLIA_INDEX_TO_SORT_ORDER[currentProductIndex]}
          showBlankOption={false}
          showSingleLineLabelOverlay
          noMargin
          size="xs"
          onChange={handleChange}
        />
      </MobileOnly>

      <TabletAndDesktopOnly>
        <LabeledSelectBox
          className="max-[767px]:hidden"
          label="Sort by"
          options={sortByOptions}
          value={ALGOLIA_INDEX_TO_SORT_ORDER[currentProductIndex]}
          showBlankOption={false}
          showSingleLineLabelOverlay
          noMargin
          size="sm"
          onChange={handleChange}
        />
      </TabletAndDesktopOnly>
    </div>
  );
};

export default ProductListingSortBy;
